import React from 'react'

const CARD_CONFIG = [
  { key: 'activeBids', label: 'ACTIVE BIDS' },
  { key: 'openProjects', label: 'OPEN PROJECTS' },
  { key: 'pipelineValue', label: 'PIPELINE VALUE' },
  { key: 'unclaimedWork', label: 'UNCLAIMED WORK' },
  { key: 'issues', label: 'ISSUES' },
]

export default function StatCards({ dashStats }) {
  return (
    <div className="stat-row">
      {CARD_CONFIG.map((cfg) => {
        const data = dashStats?.[cfg.key]
        const value = data?.value ?? '\u2014'
        const sub = data?.sub || ''
        const numClass = data?.numClass || ''
        const meter = data?.meter

        return (
          <div className="stat-card" key={cfg.key}>
            <span className="eyebrow">{cfg.label}</span>
            <span className={`num${numClass ? ' ' + numClass : ''}`}>{value}</span>
            <span className="sub">{sub}</span>
            {meter && (
              <div className="meter">
                <span className={`meter-${meter.fill}`} style={{ width: `${meter.width}%` }} />
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
